export const getCurrentStep = state => state.currentStep;

export const getProduct = state => state.product;

export const getSubProducts = state => state.subProducts;

export const getDetails = state => state.details;

export const getInformation = state => state.information;

export const getCardToken = state => state.cardToken;


export const getInvoice = state => {
    return state.invoice;
};

export const isLoading = state => state.isLoading;

export const getCardError = state => state.cardError;

export const getClientSecret = state => state.clientSecret;

export const getInvoiceLink = state => state.invoiceLink;

